/**
 * `/app/reports/$period` — one month's report document.
 *
 * The period is validated **in the route**, not in the page: `2026-13` is not a
 * month anybody can have a report for, and the honest answer to it is a not-found
 * rather than a page that renders an error where a document should be.
 * `PeriodSchema` is the same object the API validates the path with
 * (`packages/shared/src/schemas/primitives.ts`), so the two cannot disagree.
 */

import { isPeriod } from '@fareast/shared'
import { createFileRoute, notFound } from '@tanstack/react-router'

import { NotFound } from '../../../errors/NotFound.js'
import { ReportDocumentPage } from '../../../pages/client/report/ReportDocumentPage.js'

export const Route = createFileRoute('/app/reports/$period')({
  beforeLoad: ({ params }) => {
    if (!isPeriod(params.period)) throw notFound()
  },
  /** R3-13: the boundary is this route, so the portal shell outlives the refusal. */
  notFoundComponent: NotFound,
  component: ReportRoute,
})

function ReportRoute() {
  const { period } = Route.useParams()
  return <ReportDocumentPage period={period} />
}
